import React from 'react';
import './Services.css';

const services = [
  {
    img: '/assets/prp-img.png',
    icon: '/assets/icon/prp.png',
    title: 'PRP Hair Restoration',
    desc: 'Uses your own platelets to stimulate hair growth, improve thickness, and reduce hair loss. Safe and effective.',
  },
  {
    img: '/assets/SkinRejuvenation.png',
    icon: '/assets/icon/Skin-Rejuvenation.png',
    title: 'PRP Skin Rejuvenation',
    desc: 'Boosts collagen, improves skin texture, and reduces fine lines using your body\'s natural healing properties.',
  },
  {
    img: '/assets/Micro-needling.png',
    icon: '/assets/icon/Micro-needling-icon.png',
    title: 'Micro-needling',
    desc: 'Creates micro-injuries to stimulate collagen, reducing scars, wrinkles, and uneven skin texture. Can be combined with PRP.',
  },
  {
    img: '/assets/BotoxInjectables.png',
    icon: '/assets/icon/BotoxInjectables-icon.png',
    title: 'Botox Injectables',
    desc: 'Smooth wrinkles and prevent new ones.',
  },

  {
    img: '/assets/DermalFillers.png',
    icon: '/assets/icon/Dermal Fillers-icon.png',
    title: 'Dermal Fillers',
    desc: 'Restores volume, smooths wrinkles, and enhances facial contours with hyaluronic acid-based injections.',
  },
  {
    img: '/assets/PostHairTransplantTreatments.png',
    icon: '/assets/icon/prp.png',
    title: 'Post Hair Transplant Treatments',
    desc: 'Supports healing, strengthens follicles, and improves hair growth with PRP and specialized scalp treatments.',
  },
  {
    img: '/images/Dermal peels.jpg',
    icon: '/assets/icon/Skin-Rejuvenation.png',
    title: 'Dermal Peels',
    desc: 'Exfoliate and rejuvenate your skin for a brighter, smoother, and more youthful complexion.',
  },
  {
    img: '/images/facial.jpg',
    icon: '/assets/icon/Skin-Rejuvenation.png',
    title: 'Facial',
    desc: 'Deep cleansing and hydration to maintain healthy, glowing skin tailored to your specific needs.',
  },
  {
    img: '/images/medical_graded_facial_generated.png',
    icon: '/assets/icon/Skin-Rejuvenation.png',
    title: 'Medical Graded Facial',
    desc: 'Advanced treatments designed to target specific skin concerns for optimal and lasting results.',
  },
  {
    img: '/images/hydrodermabrasion.jpg',
    icon: '/assets/icon/Skin-Rejuvenation.png',
    title: 'Hydrodermabrasion',
    desc: 'Exfoliate, extract, and hydrate the skin simultaneously for a clearer, more radiant appearance.',
  },
];

const Services = ({ openModal }) => {
  return (
    <section className="services" id="our-services">
      <div className="container">
        <div className="services-header">
          <span className="section-tag">Our Services</span>
          <h2 className="section-title">What Service We Offer</h2>
          <p className="services-sub">
            At Embrace Beauty, we understand that everyone's aesthetic goals are unique.
          </p>
        </div>

        <div className="services-grid">
          {services.map((s, i) => (
            <div className="service-card" key={i}>
              <div className="service-card-img">
                <img src={s.img} alt={s.title} />
                <div className="service-card-icon">
                  <img src={s.icon} alt={s.title + ' icon'} onError={e => e.target.style.display='none'} />
                </div>
              </div>
              <div className="service-card-body">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <button className="service-btn" onClick={openModal}>Book Appointment</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
